<kendo-textbox
  placeholder="{{ 'profile.default.phone' | localize }}"
  [(ngModel)]="formData.login"
  (keydown.enter)="send()"
></kendo-textbox>
<kendo-textbox
  #passwordbox
  placeholder="{{ 'profile.default.password' | localize }}"
  [(ngModel)]="formData.password"
  [clearButton]="true"
  (keydown.enter)="send()"
>
  <ng-template kendoTextBoxSuffixTemplate>
    <button kendoButton look="clear" iconClass="k-icon fas fa-eye" (click)="toggleVisibility()"></button>
  </ng-template>
</kendo-textbox>

<button [disabled]="isSubmitBtnDisabled" class="action-button" kendoButton (click)="send()">
  <span class="k-icon k-i-loading" *ngIf="fetching; else staticText"></span>
  <ng-template #staticText>{{ localizeBasePath + '.come_in' | localize }}</ng-template>
</button>

<button kendoButton class="action-button" (click)="goToRecovery()">
  {{ localizeBasePath + '.restore_password' | localize }}
</button>

<a href="./registration">{{ 'profile.default.register' | localize }}</a>
